"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAuthentication = checkAuthentication;
exports.findTImeout = findTImeout;
exports.login = login;
exports.logout = logout;
var _EntitlementService = require("cornerstone_ui_core/lib/services/EntitlementService");
var _Timeout = _interopRequireDefault(require("cornerstone_ui_core/lib/services/Timeout.service"));
var _baseLayout = require("./base-layout.service");
var _utils = require("cornerstone_ui_core/lib//utils");
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Helper function that watches the authenticate state, then applies it
 * as a boolean (authenticated) as well as attaches the userinfo data.
 */

async function checkAuthentication() {
  const cacheKey = localStorage.getItem("jwttknkey");
  const decoded = decodedToken();
  let userid,
    appName = localStorage.getItem("AppId");
  let baseURL = window.location.origin;
  if (cacheKey && cacheKey !== "undefined" && !baseURL.includes(".com")) {
    try {
      const data = await (0, _EntitlementService.findUserSession)({
        identifierKey: cacheKey
      });
      const jwtToken = (0, _jwtDecode.default)(data.jwtToken);
      userid = jwtToken.sub;
      appName = jwtToken.App;
      //TODO : app specific key name is not required as each app has different urls
      if (appName === "RDS") {
        localStorage.setItem("rdsjwCacheKey", cacheKey);
        localStorage.setItem("rdsAppToken", data.jwtToken);
      }
      if (appName === "SCS") {
        localStorage.setItem("scsjwCacheKey", cacheKey);
        localStorage.setItem("scsAppToken", data.jwtToken);
      }
      if (appName === "GCS") {
        console.log("appName === GCS" + cacheKey);
        localStorage.setItem("gcsjwCacheKey", cacheKey);
        localStorage.setItem("gcsAppToken", data.jwtToken);
      }
    } catch (e) {
      console.error(e);
    }
  } else if (cacheKey && cacheKey !== "undefined" && cacheKey !== undefined && baseURL.includes(".com")) {
    let subCacheKey = cacheKey.split("\\");
    let useFormat = "\\\\";
    let modifiedCacheKey = subCacheKey[0] + useFormat + subCacheKey[1];
    console.log("Supplier Net", cacheKey, useFormat, modifiedCacheKey);
    const data = await (0, _baseLayout.getUserSessionService)(modifiedCacheKey);
    const jwtToken = (0, _jwtDecode.default)(data.jwtToken);
    userid = jwtToken.sub;
    appName = jwtToken.App;
  } else if (decoded) {
    userid = decoded && decoded.email ? decoded.email.split("@")[0] : null;
    appName = localStorage.getItem("AppId");
  }
  if (userid && appName && appName.length > 0 && !baseURL.includes(".com")) {
    this.props.findByUserAppAndFunctions(appName, userid);
    if (window.location.hostname.substring(0, 3) === "pds") {
      this.props.getPersonaUser(userid, appName);
    }
  } else if (userid && appName && appName.length > 0 && baseURL.includes(".com")) {
    if (decoded && decoded !== undefined && decoded !== "undefined") {
      let subUserId = userid.split("\\");
      let useFormat = "\\\\";
      let modifiedUserId = subUserId[0] + useFormat + subUserId[1];
      console.log("Decoded", decoded);
      this.props.fetchJwttokenSN(modifiedUserId, appName, decoded);
    } else {
      clearToken();
      // if (
      //   (baseURL === "scs.cornerstone-dev.elcompanies.net" ||
      //     window.location.hostname == "localhost") &&
      //   localStorage.getItem("AppId") === "SCS"
      // ) {
      //   return this.loginModal.open().then(async values => {
      //     this.setState({ renderTime: Date.now() });
      //   });
      // }
      var logoutUrl = (0, _utils.masterUrl)() + "/logout";
      window.location.href = logoutUrl;
    }
  } else {
    logout();
  }
}
function login() {
  window.location.href = (0, _utils.masterUrl)();
}

/** fetching timeout based on entitlements */
async function findTImeout() {
  let baseURL = window.location.origin;
  const appId = localStorage.getItem("AppId");
  let timeout = 15;
  if (!baseURL.includes(".com")) {
    if (appId) {
      var _response$data$getApp;
      const response = await _Timeout.default.getAppTimeout(appId);
      timeout = (_response$data$getApp = response.data.getAppTimeOut) === null || _response$data$getApp === void 0 ? void 0 : _response$data$getApp.timeout;
    }
  }
  localStorage.setItem("timeout", timeout);
}
function logout() {
  let baseURL = window.location.origin;
  if (localStorage.getItem("actionTrackingObject")) localStorage.removeItem("actionTrackingObject"); // remove action tracking portion
  if (!baseURL.includes(".com")) {
    clearToken();
    var logoutUrl = (0, _utils.masterUrl)() + "/applogout";
    window.location.href = logoutUrl;
  } else {
    clearToken();
    var logoutUrl = (0, _utils.masterUrl)() + "/logout";
    window.location.href = logoutUrl;
  }
}
function setToken(token) {
  localStorage.setItem("sessionId", token);
}
function getToken() {
  return localStorage.getItem("sessionId");
}
function clearToken() {
  localStorage.setItem("logout-triggered", "logout" + Math.random());
  sessionStorage.clear();
  //TODO: Move all user session related data to session storage
  localStorage.removeItem("sessionId");
  localStorage.removeItem("jwtToken");
}
function decodedToken() {
  const token = getToken();
  if (token && token !== "undefined") return (0, _jwtDecode.default)(token);
}
/* eslint-disable import/prefer-default-export */